import React from "react";
import Voucher from "./Voucher";
import {
    Gift
} from "lucide-react";

const VoucherGrid = ({ vouchers = [], onAdd }) => {
    if (!vouchers.length) {
        return (
        <div className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border p-12">
            <div className="text-center text-slate-700">
                <Gift className="w-12 h-12 mx-auto opacity-50" />
                <p>No vouchers found matching your criteria.</p>
            </div>
        </div>
        );
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {vouchers.map((voucher) => (
            <Voucher 
                key={voucher.title} 
                {...voucher}
                onAdd={() => onAdd(voucher)}
            />
        ))}
        </div>
    );
};

export default VoucherGrid;
